import { Link } from "react-router-dom";
import "./AppFooter.css";

function classNames(...parts) {
  return parts.filter(Boolean).join(" ");
}

export default function AppFooter({ className = "" }) {
  const currentYear = new Date().getFullYear();
  const links = [
    { label: "Terms & Privacy", to: "/privacy-policy#terms", type: "route" },
    { label: "Cookies", to: "/privacy-policy#cookies", type: "route" },
    { label: "support@baknay.com", href: "mailto:support@baknay.com", type: "external" },
  ];

  return (
    <footer role="contentinfo" className={classNames("app-footer", className)}>
      <div className="app-footer__inner">
        <p className="app-footer__copy">© {currentYear} Baknay. All rights reserved.</p>

        <nav aria-label="Baknay legal and support links">
          <ul className="app-footer__links">
            {links.map((link, index) => (
              <li key={link.label} className="app-footer__item">
                {index > 0 && (
                  <span aria-hidden="true" className="app-footer__separator">
                    •
                  </span>
                )}
                {link.type === "route" ? (
                  <Link to={link.to} className="app-footer__anchor">
                    {link.label}
                  </Link>
                ) : (
                  <a href={link.href} className="app-footer__anchor">
                    {link.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </footer>
  );
}
